import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { breadcrumbRoutes } from '@/shared/config/navigationConfig';

export const useBreadcrumb = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const breadcrumbItems = useMemo(() => {
    const items = [
      {
        title: t('navigation.home'),
      },
    ];

    if (location.pathname !== '/demo') {
      const route = breadcrumbRoutes.find(route => route.path === location.pathname);
      const pageTitle = route ? t(route.labelKey) : t('navigation.demo');

      items.push({
        title: pageTitle,
      });
    }

    return items;
  }, [location.pathname, t]);

  return { breadcrumbItems };
};